import { render, staticRenderFns } from "./IconCommoDelete.vue?vue&type=template&id=ba6babcc"
import script from "./IconCommoDelete.vue?vue&type=script&lang=js"
export * from "./IconCommoDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports